import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { orchestratorApiRoot } from '../services/session-api';

function asHttpError(err: unknown): HttpErrorResponse | null {
  return err instanceof HttpErrorResponse ? err : null;
}

/**
 * Attaches `X-User` and, when the page still holds a bearer, `Authorization`.
 * HttpOnly sessions send the cookie instead. On 401, clears session and redirects to SSO login.
 */
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const bearer = auth.getBearerAuthHeaders();
  const xUser = auth.getXUserHeader();
  const idleTimeout = auth.getIdleTimeoutHeader();
  const headers = { ...bearer, ...xUser, ...idleTimeout };
  const sendCookie = req.url.startsWith(orchestratorApiRoot());
  const cloned = req.clone({
    setHeaders: headers,
    withCredentials: sendCookie,
  });

  return next(cloned).pipe(
    tap({
      error: (err: unknown) => {
        const httpErr = asHttpError(err);
        if (httpErr?.status === 401) auth.forceSsoRelogin();
      },
    }),
  );
};
